export default {"src":"/_next/static/media/actionable_implementation_training.202b87cf.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};